
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Icon","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 1000 1000","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M595 732.8c-47.9 0-94.4-9.4-138.2-27.9-42.3-17.9-80.2-43.5-112.8-76.1-32.6-32.6-58.2-70.6-76.1-112.8-18.5-43.8-27.9-90.3-27.9-138.2s9.4-94.4 27.9-138.2c17.9-42.3 43.5-80.2 76.1-112.8 32.6-32.6 70.6-58.2 112.8-76.1 43.8-18.5 90.3-27.9 138.2-27.9 39 0 77.3 6.3 113.9 18.7 35.4 12 68.6 29.4 98.6 51.9 29.7 22.2 55.6 48.7 77.1 78.9 18.7 26.3 34.9 57.5 46.3 89h69.2L891.5 373.7 783 261.3h57.4c-44.6-94.8-138.6-155-245.4-155-149.7 0-271.5 121.8-271.5 271.5S445.3 649.3 595 649.3c117.6 0 220.7-75.1 257.4-184.9h-48.6v-72.6h175.3v72.6h-39.6c-9.3 36.7-24.8 72.5-45.1 104.3-21 32.9-47.1 62-77.6 86.4-30.8 24.7-65.2 43.9-102.2 57.1-38.4 13.7-78.6 20.6-119.6 20.6z"}}),_c('path',{staticClass:"st0",attrs:{"d":"M745.7 304.3l-352.5-.1c-8.4 23-13 47.7-13 73.6 0 118.4 96.4 214.8 214.8 214.8 57.8 0 111.5-22.9 150.7-61.5V304.3zM432.8 497.2v-79.9h199.7l-.1 79.9H432.8z"}}),_c('path',{staticClass:"st0",attrs:{"d":"M733.6 765.6c-44.4 15.9-91.1 23.9-138.6 23.9-55.5 0-109.5-10.9-160.3-32.4-42.4-17.9-81.1-42.6-115.2-73.4v4.8h-.4v1.1H119.3v-79.9h135.4c-15.3-22.4-28.4-46.3-39.1-71.6-5.7-13.4-10.6-27-14.8-40.9h-81.6v-79.9h65.9c-1.2-13.1-1.9-26.3-1.9-39.5 0-24.9 2.2-49.5 6.5-73.6H6V995h739.7V761c-4 1.6-8 3.1-12.1 4.6zM319.1 881.7H119.3v-79.9h199.8v79.9zm313.3 0H432.8v-79.9h199.7l-.1 79.9z"}})])
          )
        }
      }
    